import styled from '@emotion/styled'

export const VendorInformationContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const VendorNameContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  fontWeight: 'bold',

  '&.title': {

  },

  '&.name': {

  },
})

export const ContactContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.contactRow': {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px'
  },

  '.contactRow:last-child': {
    marginBottom: '0px'
  }
})

export const ExperienceContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

